<template>
    <header>
        <section class="bottom">
            <div class="bottom-title">
                <p>GSM</p>
            </div>

            <div style="margin-right: 20px;">
                <ejs-dropdownlist :width="100" :dataSource='currencies' :fields="{ text: 'value', value: 'key' }" v-model:value="currency"></ejs-dropdownlist>
            </div>

            <nav>
                <router-link :to="'/studies/' + this.$route.params.id"><i class="fas fa-caret-left"></i> Back</router-link>
                <a href="#" v-on:click="save"><i class="fas fa-file-excel"></i> Export</a>
                <a href="#" v-show="!isBookmarked" v-on:click="createBookmark"><i class="fas fa-bookmark"></i> Bookmark</a>
                <a href="#" v-show="isBookmarked" v-on:click="removeBookmark"><i class="far fa-bookmark"></i> Remove Bookmark</a>

            </nav>
        </section>
    </header>
    <ejs-spreadsheet id="spreadsheet" v-show="!isFormattingReduced" ref="spreadsheet" v-if="!resetting"
                     :allowEditing="true"
                     :allowCellFormatting="true"
                     :allowChart="false"
                     :allowConditionalFormat="false"
                     :allowDataValidation="false"
                     :allowDelete="true"
                     :allowFiltering="true"
                     :allowFindAndReplace="false"
                     :allowFreezePane="false"
                     :allowHyperlink="false"
                     :allowImage="false"
                     :allowInsert="true"
                     :allowMerge="false"
                     :allowNumberFormatting="true"
                     :allowOpen="false"
                     :allowResizing="true"
                     :allowSave="true"
                     :allowScrolling="true"
                     :allowSorting="true"
                     :allowUndoRedo="false"
                     :showFormulaBar="true"
                     :showRibbon="false"
                     :height="height"
                     :cellEdit="cellEdit">
    </ejs-spreadsheet>

    <div v-show="isFormattingReduced" style="width: 100%; text-align: center; color: darkred; font-family: Oswald,sans-serif;">
        <h3>Data for this GSM Report is too large to preview/format. Please click 'Export' to download a copy of this report's data</h3>
    </div>
</template>

<script>
    import api from '../modules/ApiClient';
    import { SpreadsheetComponent } from "@syncfusion/ej2-vue-spreadsheet";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
    import Bookmark from "../modules/Bookmark";
    import Session from "../modules/Session";
    import { GSMModel } from '../models/GSMModel';
    import { createElement } from '@syncfusion/ej2-base';
    import { toRaw } from 'vue';
    import { Currency, DialogMessages, ReportNames, Routes } from '../modules/Constants';

    export default {
        name: 'GSMComponent',
        components: {
            "ejs-spreadsheet": SpreadsheetComponent,
            'ejs-dropdownlist': DropDownListComponent
        },
        methods: {
            save: function () {

                this.Dialog = DialogUtility.alert({
                    title: `Exporting ${ReportNames.GSM}`,
                    content: `Exporting ${ReportNames.GSM} to Excel. ${DialogMessages.PLEASE_WAIT}`,
                    okButton: { cssClass: 'hidden' },
                    showCloseIcon: false,
                    closeOnEscape: false,
                    animationSettings: { effect: 'Zoom' }
                });

                if (this.isFormattingReduced) {
                    let data = []
                    this.Tabs.forEach(tab => {
                        let sheet = {};
                        sheet.name = tab.TabName;
                        sheet.data = tab.Display;
                        data.push(sheet);
                    });

                    fetch(Routes.EXPORT_UNFORMATTED, {
                        method: "POST",
                        body: JSON.stringify(data),
                        responseType: 'blob'
                    })
                        .then(response => {
                            response.blob().then((data) => {
                                this.Dialog.hide()
                                var anchor = createElement('a', {
                                    attrs: {
                                        download: `${ReportNames.GSM} - ${this.$route.params.id}.xlsx`
                                    },
                                });
                                var url = URL.createObjectURL(data);
                                anchor.href = url;
                                document.body.appendChild(anchor);
                                anchor.click();
                                URL.revokeObjectURL(url);
                                document.body.removeChild(anchor);
                            })
                        })
                } else {
                    this.Tabs.sort((a, b) => b.TabIndex - a.TabIndex).forEach((tab, index) => {
                        setTimeout(() => { this.$refs.spreadsheet.goTo(`${tab.TabName}!A1`) }, this.tabLoadingTimer * index);
                    });
                    setTimeout(() => { this.$refs.spreadsheet.save({ fileName: `${ReportNames.GSM} - ${this.$route.params.id}.xlsx`, url: Routes.EXPORT_FORMATTED, saveType: "Xlsx" }) }, (this.Tabs.length + 1) * this.tabLoadingTimer);
                    setTimeout(() => { this.Dialog.hide() }, (this.Tabs.length + 2) * this.tabLoadingTimer);
                }
            },
            setSpreadsheetHeight: function () {
                this.height = document.documentElement.clientHeight - document.getElementById("spreadsheet").offsetTop - 1;
            },
            createBookmark: function () {
                Bookmark.CreateBookmark(this.$route.path, `${ReportNames.GSM} | ${this.ncasData.version.ECRNumber.Value.Fields[0]} | ${this.ncasData.version.Name}`, new Date());
                this.isBookmarked = true;
                this.$emit(Bookmark.EventName);
            },
            removeBookmark: function () {
                Bookmark.RemoveBookmark(this.$route.path);
                this.isBookmarked = false;
                this.$emit(Bookmark.EventName);
            },
            cellEdit: function () {
                //JG: Used to cancel and not allow the edit as we dont want users making changes, but do want formulas to run.
                this.$refs.spreadsheet.closeEdit();
            },
            
            processTabs: function () {
                //1. -- Get Data needed for Tabs.
                let data = toRaw(this.ncasData);
                data.currency = this.currency;

                //2. -- Determine Saleable Parts
                let saleableParts = [];
                data.snapshots.forEach(snapshot => {
                    let parts = snapshot.SaleableParts;

                    parts.forEach(function (item) {
                        let i = saleableParts.findIndex(x => x?.Part?.Number?.Fields[0] === item?.Part?.Number?.Fields[0]
                            && item?.Part?.DrawingRevision?.Fields[0]?.Fields[0] === x?.Part?.DrawingRevision?.Fields[0]?.Fields[0]
                            && item?.Part?.Suffix?.Fields[0]?.Fields[0] === x?.Part?.Suffix?.Fields[0]?.Fields[0]);
                        if (i <= -1) {
                            saleableParts.push(item);
                        }
                    });
                });

                //3. -- Generate Tab Models
                this.Tabs.filter(x => x.SaleablePart === undefined).forEach(tab => {
                    //3A -- Process Tab Data
                    let result = tab.process(data)
                    let resultData = Object.assign({}, result)
                    let model = GSMModel.PopulateGSM(resultData)
                    this.Tabs.push(model);
     
                });

                //4. Handle Sheets in Spreadsheet Comp. 
                if (this.Tabs.filter(x => x.isFormattingReduced === true).length > 0) {
                    this.isFormattingReduced = true;
                }
                if (this.isFormattingReduced === false) {
                    this.Tabs.sort((a, b) => b.TabIndex - a.TabIndex).forEach(tab => {
                        let data = tab.formatSheet();

                        let sheet = {
                            name: tab.TabName,
                            rows: data.rows,
                            columns: data.columns
                        }
                        this.$refs.spreadsheet.insertSheet([sheet]);
                        this.$refs.spreadsheet.applyFilter();

                    });
                    this.$refs.spreadsheet.refresh();
                }

                //5. Close Loader
                this.Dialog.hide();
            }
        },
        data() {
            return {
                currencies: [],
                currency: Currency.USD,
                height: 800,
                isBookmarked: false,
                tabLoadingTimer: 3500,
                ncasData: null,
                Tabs: [new GSMModel()],
                Dialog: null,
                isFormattingReduced: false,
                resetting: false
            };
        },
        mounted() {
            //1. Initialize Page
            document.title = `${ReportNames.TAB_PREFIX} - ${ReportNames.GSM}`;
            window.addEventListener('resize', this.setSpreadsheetHeight);
            this.setSpreadsheetHeight();
            this.isBookmarked = Bookmark.IsBookmarked(this.$route.path);

            //2. Load the Data
            Session.WaitToBeAuthenticated(() => {
                //A. -- Display Loader
                this.Dialog = DialogUtility.alert({
                    title: `Loading ${ReportNames.GSM}`,
                    content: `Loading ${ReportNames.GSM} data from NCAS. ${DialogMessages.PLEASE_WAIT}`,
                    okButton: { cssClass: 'hidden' },
                    showCloseIcon: false,
                    closeOnEscape: false,
                    animationSettings: { effect: 'Zoom' }
                });

                //B. -- Call NCAS APIs for Data
                Promise.all([
                    api.GetCostStudy(this.$route.params.id, this.$route.params.ver),
                    api.GetSnapshots(this.$route.params.id, this.$route.params.ver),
                    api.GetAvailableVersions(this.$route.params.id)
                ]).then(data => {
                    //B-1 -- Store API data for Use Later.
                    let apiData = {};
                    apiData.study = data[0];
                    apiData.snapshots = data[1];
                    apiData.version = data[2].find(v => v.Version.id.toLowerCase() === this.$route.params.ver.toLowerCase()).Version;
                    apiData.currency = this.currency;
                    this.ncasData = apiData;

                    //B-2 -- Get Currencies for Dropdown.
                    let fxRates = []
                    apiData.study.exchangeRates.forEach(rate => {
                        rate.Item2.Values.forEach(item => {
                            fxRates.push({
                                currency: rate.Item1,
                                year: new Date(item.Date).getUTCFullYear(),
                                value: item.Value
                            });
                        });
                    });
                    this.currencies = [...new Set(fxRates.map(x => x.currency))].map(x => {
                        return { key: x, value: x }
                    });

                    //B-3 -- Load Spreadsheet Tabs.
                    this.processTabs();
                    
                }).catch(() => {
                    //B-Error -- Hide any open loaders and display error message.
                    this.Dialog.hide();
                    DialogUtility.alert({
                        title: `Error Loading ${ReportNames.GSM}`,
                        content: `There was an error while loading this ${ReportNames.GSM}. ${DialogMessages.ERROR}`,
                        okButton: { text: 'OK', click: function () { this.hide() } },
                        showCloseIcon: false,
                        closeOnEscape: false,
                        animationSettings: { effect: 'Zoom' }
                    });
                });
            });
        },
        unmounted() {
            window.removeEventListener('resize', this.setSpreadsheetHeight);
        },
        watch: {
            currency: function () {
                //1. -- Show loader
                this.Dialog = DialogUtility.alert({
                    title: 'Running FX Conversion',
                    content: `Running FX Conversion on ${ReportNames.GSM}. ${DialogMessages.PLEASE_WAIT}`,
                    okButton: { cssClass: 'hidden' },
                    showCloseIcon: false,
                    closeOnEscape: false,
                    animationSettings: { effect: 'Zoom' }
                });

                //2. -- Delete all exisiting tabs.
                if (this.isFormattingReduced === false) {
                    this.resetting = true;
                    this.$nextTick(() => {
                        this.resetting = false;
                    })
                }
                //3. -- Remove Saleable Part specific tabs, as they will be added back later.
                this.Tabs = this.Tabs.filter(x => x.SaleablePart === undefined);

                //4. -- Load Spreadsheet Tabs.
                setTimeout(() => { this.processTabs() }, 2000)

            }
        }
    }
</script>